import Image from "next/image";
import styles from "./BlogCard.module.css";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import Thumbnail from "./thumbnail.png";

const BlogCard = (props) => {


  // const carddata = [
  //   {
  //     thumbnail: Thumbnail,
  //     title: "Make Classroom Prep Hassle-Free and Fun squamate ",
  //     description:"Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
  //     //onClick:onClick,
  //     link: "https://www.google.co.uk/",
  //   },
  // ];

{/* <BlogCard 
  col="4" 
  buttonlabel="Read More" 
  carddata={carddata}
  buttoncolor="#004FE0" 
/> */}

  return (
    <>
      <Grid container spacing={2}>
        {props.carddata?.map((item, i) => (
          <Grid item xs={12} md={props.col}>
            <Card
              sx={{
                borderRadius: "10px !important",
                boxShadow: "0px 1px 2px 2px rgba(0, 0, 0, 0.04) !important",
                "&:hover": {
                  backgroundColor: "#fff",
                },
                
              }}    
            >
              <CardActionArea 
                sx={{
                  display:"block !important",
                  "&:hover": {
                    backgroundColor: "#fff",
                  },
                }}
                onClick={item.onClick}
                href={item.link}
                target="_blank"
              >
                <Image
                  src={item.thumbnail}
                  style={{ width: "100%", }}
                  alt={item.title}
                  title={item.title}
                  width={200}
                  height={props.thumbnailHeight}
                  className={styles.ThumbnailContainer}
                />

                <CardContent
                  sx={{
                    padding: "16px",
                    paddingTop: "10px",
                    paddingBottom:"8px",
                    "&:hover": {
                      backgroundColor: "#fff !important",
                    },
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      fontSize: "20px",
                      color: "#001233",
                      fontWeight: 600,
                      lineHeight: "28px",
                      marginBottom:"0",
                    }}
                  >

                  {item.title.length > 55 ? `${item.title.substring(0, 55)}...` : item.title}

                  </Typography>

                  {item.description && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#5C677D",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        marginTop:"8px",
                      }}
                    >
                      {item.description.length > 90 ? `${item.description.substring(0, 90)}...` : item.description}
                    </Typography>
                  )}
                </CardContent>
              </CardActionArea>

              <CardActions sx={{padding:"16px !important", paddingBottom: "20px !important", }}>
                <Button
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "20px",
                    color:"#004FE0 !important",
                    padding:"0 !important"
                  }}
                  onClick={item.onClick}
                  href={item.link}
                  target="_blank"
                >
                  {props.buttonlabel}
                  <ArrowForwardIcon
                    sx={{ marginLeft: "8px", fontSize: "20px" }}
                  />
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default BlogCard;
